import React from 'react';
import { logDeprecation } from '../../../util/logging';
// eslint-disable-next-line zillow/import/no-named-default
import { default as FaceHappy, FaceHappySVG } from './IconFaceHappy';
export var SmileyFaceSVG = FaceHappySVG;
var SmileyFace = function SmileyFace(props) {
  logDeprecation("`IconSmileyFace` has been deprecated, use `IconFaceHappy`");
  return /*#__PURE__*/React.createElement(FaceHappy, props);
};
SmileyFace.displayName = 'IconSmileyFace';
export default SmileyFace;